import FilterModal from "src/components/common/FilterFrame/FilterModal";
import type { FilterFieldConfig } from "src/components/common/FilterFrame/FilterModal";
import { pipelineOptions, regionOptions, subPipelineOptions } from "src/components/common/functions";

const yesNoFilter = [
    { value: "yes", label: "Yes" },
    { value: "no", label: "No" },
];

export const fields: FilterFieldConfig[] = [
    { key: "projectNumber", label: "Project Number", type: "text", default: "" },
    { key: "organizationName", label: "Client Name", type: "text", default: "" },
    { key: "clientProjectNumber", label: "Client Project Name / Job Number / PM Number", type: "text", default: "" },
    { key: "projectManager", label: "Project Manager", type: "text", default: "" },
    {
        key: "pipeline",
        label: "Pipeline",
        type: "select",
        default: "",
        options: Object.keys(pipelineOptions).map(value => ({ value, label: value })),
    },
    {
        key: "subPipeline",
        label: "Sub Pipeline",
        type: "select",
        default: "",
        options: Array.from(new Set(Object.values(subPipelineOptions).flat())).map(value => ({ value, label: value })),
    },
    {
        key: "stage",
        label: "Stage",
        type: "select",
        default: "",
        options: Array.from(new Set(Object.values(pipelineOptions).flat())).map(value => ({ value, label: value })),
    },
    {
        key: "reportNeeded",
        label: "Report Needed",
        type: "select",
        default: "",
        options: [
            { value: "Yes", label: "Yes" },
            { value: "No", label: "No" },
        ],
    },
    { key: "prevailing", label: "Prevailing Job", type: "select", default: "", options: yesNoFilter },
    { key: "cpr", label: "Certified Payroll", type: "select", default: "", options: yesNoFilter },
    { key: "location", label: "Location", type: "text", default: "" },
    { key: "nearestMedicalFacility", label: "Nearest Medical Facility", type: "text", default: "" },
    { key: "opportunityName", label: "Opportunity", type: "text", default: "" },
    { key: "proposalNumber", label: "Proposal", type: "text", default: "" },
    { key: "requestor", label: "Requestor", type: "text", default: "" },
    { key: "clientPONumber", label: "Client PO", type: "text", default: "" },
    {
        key: "region",
        label: "Region",
        type: "select",
        default: "",
        options: regionOptions.map(value => ({ value, label: value })),
    },
    { key: "usaTicketNumber", label: "USA Ticket Number", type: "text", default: "" },
    { key: "usaTicketDate", label: "USA Ticket Date", type: "range", default: "", inputType: "date" },
    {
        key: "billingType",
        label: "Billing Type",
        type: "select",
        default: "",
        options: [
            { value: "Day Rate", label: "Day Rate" },
            { value: "T & M", label: "T & M" },
        ],
    },
    { key: "days", label: "Estimate Days", type: "range", default: "", inputType: "number" },
    { key: "laborHours", label: "Estimate Labor Hours", type: "range", default: "", inputType: "number" },
    { key: "materialCost", label: "Estimate Material Cost", type: "range", default: "", inputType: "number" },
    { key: "accurateTime", label: "Accurate Time On Job Tag", type: "select", default: "", options: yesNoFilter },
    { key: "clientSignatureRequired", label: "Client Signature Required", type: "select", default: "", options: yesNoFilter },
    { key: "sendToClient", label: "Send To Client", type: "select", default: "", options: yesNoFilter },
    { key: "creator", label: "Creator", type: "text", default: "" },
    { key: "projectCreationDate", label: "Date Created", type: "range", default: "", inputType: "date" },
    { key: "updater", label: "Updater", type: "text", default: "" },
    { key: "projectDateUpdated", label: "Date Updated", type: "range", default: "", inputType: "date" },
    { key: "description", label: "Description", type: "text", default: "" },
    { key: "notes", label: "Notes", type: "text", default: "" },
];

export default function ProjectFilterForm() {
    return <FilterModal title="Filter" width={700} fields={fields} />;
}
